import React from 'react'
import { compose } from 'recompose'
import { withStyles, Grid } from '@material-ui/core'
import EmojiObjectsIcon from '@material-ui/icons/ArrowBack'
import themeCreateInjectableStyles from 'Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support'
import alertStyle from './Alert.style'
import cn from 'classnames'
import Icons from 'Components/Icons/Icons.component'

const CustomisedIcon: any = Icons

interface Props {
  content: React.ReactNode,
}
interface InjectedProps {
  classes: any,
}
const AlertComp = (props: Props & InjectedProps) => {
  const {
    content,
    classes,
  } = props
  return (
    <div className={classes.wrapper}>
      <div className={cn(classes.displayFlex)}>
          <CustomisedIcon size='24' color='#00a94f' type='EMOJI_OBJECTS' className={classes.lightBulb} />
          <div className={cn(classes.contentText)}>
            { content }
          </div>
      </div>
    </div>
  )
}

const Alert = compose<Props & InjectedProps, Props>(
  withStyles(themeCreateInjectableStyles(alertStyle) as any, { withTheme: true }),
)(AlertComp)

export default Alert
